// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_product-recommendations.scss';

// -------------------------------------
// Variables
// -------------------------------------

var CAROUSEL_SELECTOR = '.carousel--related-products';
var CAROUSEL_CLASS = 'carousel--related-products';
var CAROUSEL_SECTION_SELECTOR = '.related-products';
var CAROUSEL_SECTION_CLASS = 'related-products';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// Selectors
var RECOMMENDATIONS_SELECTOR = '.product-recommendations';

// -------------------------------------
// Helpers
// -------------------------------------

var initProductRecommendations = () => {
  var productRecommendations = document.querySelectorAll(RECOMMENDATIONS_SELECTOR);
  productRecommendations.forEach(productRecommendation => {
    handleIntersection([{
      target: productRecommendation,
      isIntersecting: true
    }], null);
  });
};
var handleIntersection = entries => {
  if (!entries[0].isIntersecting) return;
  var $elem = entries[0].target;
  var url = $elem.dataset.url;
  fetch(url).then(response => response.text()).then(text => {
    var html = document.createElement('div');
    html.innerHTML = text;
    var recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);
    var recommendationsCarousel = recommendations.querySelector(CAROUSEL_SELECTOR);
    var sectionID = recommendations.dataset.sectionId;
    recommendations.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(sectionID));
    recommendations.querySelectorAll(CAROUSEL_PREV_BUTTON_SELECTOR).forEach(btn => btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(sectionID)));
    recommendations.querySelectorAll(CAROUSEL_NEXT_BUTTON_SELECTOR).forEach(btn => btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(sectionID)));
    recommendations.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(sectionID));
    if (recommendations && recommendations.innerHTML.trim().length) {
      $elem.innerHTML = recommendations.innerHTML;
      if (recommendationsCarousel != null) {
        var swiper = new Swiper("".concat(CAROUSEL_SELECTOR, "-").concat(sectionID), {
          modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
          slidesPerView: 1.2,
          spaceBetween: 0,
          watchOverflow: true,
          // Do not turn into sliders if number of slides is less than slidesPerView.
          keyboard: true,
          observer: true,
          observeParents: true,
          a11y: {
            slideRole: null
          },
          simulateTouch: true,
          breakpoints: {
            // when window width is >= 768px
            768: {
              slidesPerView: 3.2,
              spaceBetween: 16
            }
          },
          pagination: {
            el: "".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(sectionID),
            clickable: true,
            renderBullet: function renderBullet(bulletIndex, className) {
              var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
              return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
            }
          },
          navigation: {
            nextEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-next-").concat(sectionID),
            prevEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-prev-").concat(sectionID)
          },
          on: {
            init() {
              // to fix Lazy load issue on mobile device
              removeLazyFromVisibleSlides(this);
            },
            slideChange() {
              var bullets = recommendations.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(sectionID, " .swiper-pagination-bullet"));
              bullets.forEach((bullet, bulletIndex) => {
                if (bulletIndex === swiper.activeIndex) {
                  bullet.setAttribute('aria-current', 'true');
                } else {
                  bullet.removeAttribute('aria-current');
                }
              });
              removeLazyFromVisibleSlides(this);
            }
          }
        });

        // Move to corresponding slide when Enter is pressed into pagination bullet
        var paginationBullets = recommendations.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(sectionID, " .swiper-pagination-bullet"));
        paginationBullets.forEach((bullet, bulletIndex) => {
          bullet.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); // prevent scrolling for space
              swiper.slideTo(bulletIndex);
            }
          });
        });
      }
    }
  }).catch(e => {
    console.error(e);
  });
};
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.card__main-image[loading="lazy"]');
      if (img) {
        img.removeAttribute('loading');
      }
    }
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  initProductRecommendations();
});